import { render, staticRenderFns } from "./show-model.vue?vue&type=template&id=50a8590c&"
import script from "./show-model.vue?vue&type=script&lang=js&"
export * from "./show-model.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports